export default {"src":"/_next/static/media/excedentes2.b9f63730.svg","height":120,"width":131};